// Vendor libraries
import { ElementRef } from '@angular/core';
// Services
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import * as i0 from "@angular/core";
import * as i1 from "SecuritiesApp/ts/services/securities.service";
import * as i2 from "@angular/common";
import * as i3 from "SecuritiesApp/ts/features/holdings-history-table/holdings-history-table.component";
import * as i4 from "../module-upsell/module-upsell.component";
function HoldingsHistoryComponent_div_0_div_2_ycn_holdings_history_table_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-holdings-history-table", 7);
} if (rf & 2) {
    const holdingDate_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("securityId", ctx_r1.securityId)("displaySecurityId", ctx_r1.displaySecurityId)("initialHoldingDate", holdingDate_r1)("holdingDates", ctx_r1.holdingDates);
} }
function HoldingsHistoryComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, HoldingsHistoryComponent_div_0_div_2_ycn_holdings_history_table_1_Template, 1, 4, "ycn-holdings-history-table", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r3 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", index_r3 < 4);
} }
function HoldingsHistoryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtemplate(2, HoldingsHistoryComponent_div_0_div_2_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.holdingDates);
} }
function HoldingsHistoryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵelement(2, "div", 10)(3, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵelement(5, "ycn-module-upsell", 13);
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵtext(7, "No data available");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "table", 15)(9, "tbody")(10, "tr")(11, "td");
    i0.ɵɵtext(12, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "tr")(14, "td");
    i0.ɵɵtext(15, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "tr")(17, "td");
    i0.ɵɵtext(18, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "tr")(20, "td");
    i0.ɵɵtext(21, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "tr")(23, "td");
    i0.ɵɵtext(24, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "tr")(26, "td");
    i0.ɵɵtext(27, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(28, "tr")(29, "td");
    i0.ɵɵtext(30, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(31, "tr")(32, "td");
    i0.ɵɵtext(33, "\u00A0");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "tr")(35, "td");
    i0.ɵɵtext(36, "\u00A0");
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("title", "Historical Holdings");
} }
/**
 * HoldingsHistoryComponent
 *
 * Displays 4 tables, each showing holdings data for a fund at different points in time.

 */
export class HoldingsHistoryComponent {
    constructor(el, securitiesService) {
        this.el = el;
        this.securitiesService = securitiesService;
        this.securityId = el.nativeElement.getAttribute('securityId');
        this.displaySecurityId = el.nativeElement.getAttribute('displaySecurityId');
    }
    ngOnInit() {
        this.securitiesService.getAllHoldingDates(this.securityId).subscribe((response) => {
            this.holdingDates = response.holding_dates.map((dateString) => new Date(dateString));
        }, () => {
            this.holdingDates = [];
        });
    }
}
HoldingsHistoryComponent.ɵfac = function HoldingsHistoryComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HoldingsHistoryComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.SecuritiesService)); };
HoldingsHistoryComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsHistoryComponent, selectors: [["ycn-holdings-history"]], standalone: false, decls: 2, vars: 2, consts: [["class", "tab-pane active", 4, "ngIf"], ["class", "panel panel-data", 4, "ngIf"], [1, "tab-pane", "active"], [1, "row", "panels-row", "ng-scope"], ["class", "col-6", 4, "ngFor", "ngForOf"], [1, "col-6"], [3, "securityId", "displaySecurityId", "initialHoldingDate", "holdingDates", 4, "ngIf"], [3, "securityId", "displaySecurityId", "initialHoldingDate", "holdingDates"], [1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions"], [1, "panel-content"], [3, "title"], [1, "panel-data-empty-message"], [1, "table"]], template: function HoldingsHistoryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, HoldingsHistoryComponent_div_0_Template, 3, 1, "div", 0)(1, HoldingsHistoryComponent_div_1_Template, 37, 1, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.holdingDates && ctx.holdingDates.length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.holdingDates && !ctx.holdingDates.length);
    } }, dependencies: [i2.NgForOf, i2.NgIf, i3.HoldingsHistoryTableComponent, i4.ModuleUpsellComponent], encapsulation: 2 });
